import moment from "moment";

// Same default as the backend (utils/heartbeat.js) for printers the admin never changed.
export const DEFAULT_HEARTBEAT_MINUTES = 5;

// The backend sets offlineAfter on every heartbeat, so the admin does not repeat its rule.
export const connectionOf = (printer) => {
  if (!printer.lastSeenAt) return "never";
  return new Date(printer.offlineAfter).getTime() > Date.now()
    ? "online"
    : "offline";
};

export const lastSeenText = (printer) =>
  printer.lastSeenAt ? moment(printer.lastSeenAt).fromNow() : "Never";

export const heartbeatMinutes = (printer) =>
  printer.heartbeatIntervalSec
    ? printer.heartbeatIntervalSec / 60
    : DEFAULT_HEARTBEAT_MINUTES;
